import React, { useEffect } from "react";
import "./TermsOfService.css";
import { Link } from "react-router-dom";

const TermsOfService = () => {
  useEffect(() => {
    document.title = "Terms of Service | The Party Parlour";
  }, []);

  return (
    <div className="terms-page">
      <div className="terms-container">
        <h1>Terms of Service</h1>
        <p className="terms-updated">Last updated: September 1, 2026</p>

        <p>
          These Terms of Service ("Terms") govern your use of The Party
          Parlour's website and the photo booth rental services we provide
          (the "Services"). By booking with us or using this site, you agree
          to these Terms. Please read them carefully.
        </p>

        <h2>1. Our Services</h2>
        <p>
          The Party Parlour provides portable photo booth rentals for private
          and corporate events, including on-site setup, an attendant, custom
          photo templates, instant digital delivery, and optional add-ons
          such as prints and backdrops. Specific inclusions depend on the
          package you select.
        </p>

        <h2>2. Bookings and Deposits</h2>
        <p>
          A booking is confirmed only once we have accepted your request and
          received any required deposit. Deposits reserve your date and time
          and may be non-refundable as described in Section 4. Prices,
          packages, and add-ons are as quoted at the time of booking.
        </p>

        <h2>3. Payment</h2>
        <p>
          Unless otherwise agreed in writing, the remaining balance is due
          before or on the day of your event. Add-ons requested on the day of
          the event are billed at the rates then in effect.
        </p>

        <h2>4. Cancellations and Rescheduling</h2>
        <ul>
          <li>
            Requests to cancel or reschedule must be sent to us in writing as
            early as possible.
          </li>
          <li>
            Deposits are generally non-refundable but may be applied to a
            rescheduled date, subject to availability.
          </li>
          <li>
            If we are unable to provide the Services due to circumstances
            beyond our reasonable control (for example, severe weather, power
            failure, or equipment failure), our liability is limited to a
            refund of amounts paid for the affected Services.
          </li>
        </ul>

        <h2>5. Your Responsibilities</h2>
        <ul>
          <li>
            Provide accurate event details, including venue address, access
            times, and the guest count.
          </li>
          <li>
            Ensure a suitable, level, sheltered space of adequate size and a
            standard power outlet within reasonable distance of the booth.
          </li>
          <li>
            Obtain any permissions required by your venue and ensure safe
            access for setup and teardown.
          </li>
          <li>
            Be responsible for the conduct of your guests. You agree to
            reimburse us for loss or damage to our equipment caused by you or
            your guests, other than normal wear and tear.
          </li>
        </ul>

        <h2>6. Photos, Media, and Consent</h2>
        <p>
  Guests who use the booth do so voluntarily. You are responsible for
  informing your guests that photos are being taken. We may use a
  limited selection of event photos to promote our Services (for
  example, on our website or social media). If you or a guest would
  prefer that images not be used for promotion, let us know in
  writing and we will honour that request. See our{" "}
  <Link to="/PrivacyPolicy">Privacy Policy</Link>{" "}
  for how we handle personal information and images.
</p>

        <h2>7. Intellectual Property</h2>
        <p>
          All content on this website, including text, graphics, logos, and
          photo templates, is owned by or licensed to The Party Parlour and
          may not be copied or reused without permission.
        </p>

        <h2>8. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, The Party Parlour is not
          liable for indirect, incidental, or consequential damages arising
          from the Services or your use of this site. Our total liability
          for any claim relating to the Services will not exceed the amount
          you paid for the affected booking. Nothing in these Terms limits
          liability that cannot be limited under applicable law.
        </p>

        <h2>9. Indemnity</h2>
        <p>
          You agree to indemnify and hold The Party Parlour harmless from
          claims arising out of your event, your breach of these Terms, or
          the conduct of your guests.
        </p>

        <h2>10. Governing Law</h2>
        <p>
          These Terms are governed by the laws of the Province of Ontario and
          the federal laws of Canada applicable there, without regard to
          conflict-of-law rules.
        </p>

        <h2>11. Changes to These Terms</h2>
        <p>
          We may update these Terms from time to time. The version in effect
          at the time of your booking applies to that booking. Continued use
          of the site after changes are posted constitutes acceptance of the
          updated Terms.
        </p>

         <h2>12. Contact</h2>
        <p>
          Questions about these Terms? Reach us through the{" "}
          <Link to="/Contact">contact form on our homepage</Link>.
        </p>
      </div>
    </div>
  );
};

export default TermsOfService;